// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";
import { ReturnRequestResultModel, SubmitReturnRequestApiParameter } from "@store/Framework/Types/ApiModels";

export const customInvoicesServiceUrl = "/api/v1/custom/invoices";

export function submitReturnRequest(parameter: SubmitReturnRequestApiParameter) {
    return post<SubmitReturnRequestApiParameter, ReturnRequestResultModel>(`${customInvoicesServiceUrl}/rma`, parameter);
}
